document.querySelectorAll('.tabs button').forEach((button) => {
  button.addEventListener('click', () => {
    document.querySelectorAll('.tabs button').forEach((item) => item.classList.remove('active'));
    button.classList.add('active');
  });
});

document.querySelectorAll('.thumbs img').forEach((thumbnail) => {
  thumbnail.addEventListener('click', () => {
    const gallery = thumbnail.closest('.gallery');
    const mainImage = gallery && gallery.querySelector('.main-media img');
    if (!mainImage) return;
    gallery.querySelectorAll('.thumbs img').forEach((item) => item.classList.remove('active'));
    thumbnail.classList.add('active');
    mainImage.src = thumbnail.src;
    mainImage.alt = thumbnail.alt || mainImage.alt;
  });
});

document.querySelectorAll('.choice-row').forEach((row) => {
  row.querySelectorAll('.choice').forEach((choice) => {
    choice.addEventListener('click', () => {
      row.querySelectorAll('.choice').forEach((item) => item.classList.remove('active'));
      choice.classList.add('active');
      const option = row.closest('.option');
      const label = option && option.querySelector('strong');
      if (label) label.textContent = `${label.textContent.split(':')[0]}: ${choice.textContent.trim()}`;
    });
  });
});

document.querySelectorAll('.lifestyle-carousel').forEach((carousel) => {
  const track = carousel.querySelector('.lifestyle-track');
  const slides = [...track.querySelectorAll('figure')];
  const previous = carousel.querySelector('.lifestyle-prev');
  const next = carousel.querySelector('.lifestyle-next');
  const count = carousel.querySelector('.lifestyle-count');
  let index = 0;
  let timer;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const update = () => {
    count.textContent = `${index + 1} / ${slides.length}`;
    previous.disabled = false;
    next.disabled = false;
  };

  const move = (direction) => {
    index = (index + direction + slides.length) % slides.length;
    track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    update();
  };

  const stop = () => window.clearInterval(timer);
  const start = () => {
    stop();
    if (!reduceMotion && slides.length > 1) timer = window.setInterval(() => move(1), 5000);
  };

  previous?.addEventListener('click', () => { move(-1); start(); });
  next?.addEventListener('click', () => { move(1); start(); });
  carousel.addEventListener('mouseenter', stop);
  carousel.addEventListener('mouseleave', start);
  carousel.addEventListener('focusin', stop);
  carousel.addEventListener('focusout', start);
  track.addEventListener('scroll', () => {
    const nearest = slides.reduce((best, slide, slideIndex) => {
      const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
      return distance < best.distance ? { index: slideIndex, distance } : best;
    }, { index: 0, distance: Infinity });
    index = nearest.index;
    update();
  }, { passive: true });
  update();
  start();
});

document.querySelectorAll('.hero-carousel').forEach((carousel) => {
  const slides = [...carousel.querySelectorAll('.hero-slide')];
  const previous = carousel.querySelector('.hero-prev');
  const next = carousel.querySelector('.hero-next');
  const dots = carousel.querySelector('.hero-dots');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let index = 0;
  let timer;

  if (!slides.length) return;

  slides.forEach((slide, slideIndex) => {
    const dot = document.createElement('button');
    dot.className = `hero-dot${slideIndex === 0 ? ' active' : ''}`;
    dot.setAttribute('aria-label', `Show featured image ${slideIndex + 1}`);
    dot.addEventListener('click', () => show(slideIndex, true));
    dots?.appendChild(dot);
  });

  const show = (nextIndex, restart = false) => {
    index = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => slide.classList.toggle('active', slideIndex === index));
    if (dots) [...dots.children].forEach((dot, dotIndex) => dot.classList.toggle('active', dotIndex === index));
    if (restart) start();
  };

  const stop = () => window.clearInterval(timer);
  const start = () => {
    stop();
    const interval = Number(carousel.dataset.interval) || 5000;
    if (!reduceMotion && slides.length > 1) timer = window.setInterval(() => show(index + 1), interval);
  };

  previous?.addEventListener('click', () => show(index - 1, true));
  next?.addEventListener('click', () => show(index + 1, true));
  carousel.addEventListener('mouseenter', () => { stop(); carousel.classList.add('is-paused'); });
  carousel.addEventListener('mouseleave', () => { carousel.classList.remove('is-paused'); start(); });
  carousel.addEventListener('focusin', stop);
  carousel.addEventListener('focusout', start);
  start();
});

// The storefront is English-first. Shopify can render Search & Discovery
// filter labels from the visitor locale, so normalize the two visible labels
// that otherwise appeared in Chinese on collection pages.
const normalizeCollectionLabels = (root = document) => {
  const replacements = new Map([
    ['供货情况', 'Availability'],
    ['价格', 'Price'],
    ['排序', 'Sort'],
    ['筛选条件', 'Filters']
  ]);
  root.querySelectorAll('summary, button, label, span').forEach((element) => {
    const label = element.textContent.trim();
    if (replacements.has(label)) element.textContent = replacements.get(label);
  });
};
normalizeCollectionLabels();
if (document.querySelector('collection-component')) {
  new MutationObserver(() => normalizeCollectionLabels()).observe(document.body, { childList: true, subtree: true });
}
